import { Suspense, useState } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { H4 } from '@/components/sv/typographies'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { EventDeliveryList } from '@/routes/webhook/tabs/event-deliveries/event-delivery-list'
import { EventDeliveryListFallback } from '@/routes/webhook/tabs/event-deliveries/event-delivery-list/fallback'
import { EventDeliveryListHeader } from '@/routes/webhook/tabs/event-deliveries/event-delivery-list/header'
import { NewEventsIndicator } from '@/routes/webhook/tabs/event-deliveries/event-delivery-list/new-events-indicator'
import { EventDetails } from '@/routes/webhook/tabs/event-deliveries/event-details'
import { EventDetailsFallback } from '@/routes/webhook/tabs/event-deliveries/event-details/fallback'
import { EventDeliveriesTabFallback } from '@/routes/webhook/tabs/event-deliveries/fallback'

export type FilterType = {
  idEvent?: string
  status?: string
}

export const EventDeliveriesTab = () => {
  const [filters, setFilters] = useState<FilterType>({})

  return (
    <LayoutPage
      browserTitle="Webhook event deliveries"
      fallback={<EventDeliveriesTabFallback />}
    >
      <div className="grid grid-cols-2">
        <Card className="rounded-r-none gap-2">
          <CardHeader>
            <CardTitle>
              <H4>Events</H4>
            </CardTitle>
            <CardAction>
              <Suspense fallback={null}>
                <NewEventsIndicator filters={filters} />
              </Suspense>
            </CardAction>
          </CardHeader>
          <CardContent>
            <EventDeliveryListHeader
              filters={filters}
              setFilters={setFilters}
            />
            <Suspense fallback={<EventDeliveryListFallback />}>
              <EventDeliveryList filters={filters} />
            </Suspense>
          </CardContent>
        </Card>
        <Card className="rounded-l-none border-l-0 p-0">
          <CardContent className="p-0">
            <Suspense fallback={<EventDetailsFallback />}>
              <EventDetails />
            </Suspense>
          </CardContent>
        </Card>
      </div>
    </LayoutPage>
  )
}
